import type { JSX } from 'react';
import { Link } from 'react-router-dom';

import { NerdyParadiseLogo } from '../logos';

interface ShellLogoProps {
  /** Mobile variant collapses the wordmark, leaving only the 24px mark. */
  variant?: 'desktop' | 'mobile';
  /** Href for the logo link. Defaults to `/` (the launcher). */
  to?: string;
}

/**
 * The signature top-left logo: Nerdy Paradise mark + italic Fraunces wordmark.
 * Mobile variant shrinks to mark-only to save horizontal space.
 *
 * Styled by `.shell__logo` / `.shell__logo-mark` / `.shell__logo-name`
 * from `shared/platform/theme/tokens.css`.
 */
export function ShellLogo({ variant = 'desktop', to = '/' }: ShellLogoProps): JSX.Element {
  const markSize = variant === 'mobile' ? 24 : 32;
  return (
    <Link to={to} className="shell__logo" aria-label="Nerdy Paradise home">
      <NerdyParadiseLogo size={markSize} className="shell__logo-mark" />
      {variant === 'desktop' && (
        <span
          className="shell__logo-name"
          style={{ fontStyle: 'italic', fontWeight: 400 }}
        >
          Nerdy Paradise
        </span>
      )}
    </Link>
  );
}
